import dayjs from 'dayjs';
import { ISalesDateRules } from 'modules/Configuration/appConfig/type/appConfig_Type';

const datePickerRules = {
  disable: {
    pastDates: false,
    futureDates: true,
  },
  pastDateLimit: {
    enabled: false,
    maxDaysBeforeToday: 2,
    cutoffTime: '10:29',
  },
};

// export const getDisabledDate = (
//   current: dayjs.Dayjs,
//   datePickerRules: ISalesDateRules | undefined,
// ) => {
//   const today = dayjs();
//   const now = dayjs();

//   if (!current) return false;

//   // Disable future dates
//   if (!datePickerRules?.futureDates) {
//     if (current.isAfter(today, 'day')) {
//       return true;
//     }
//   }

//   // Handle past date limit logic
//   if (datePickerRules?.enabled) {
//     const maxPastDate = today.subtract(datePickerRules?.maxDaysBeforeToday, 'day');

//     // Over past limit
//     if (current.isBefore(maxPastDate, 'day')) {
//       return true;
//     }

//     // Cutoff time logic
//     const [cutHour, cutMinute] = datePickerRules?.cutoffTime.split(':');

//     const cutoffDateTime = today.hour(Number(cutHour)).minute(Number(cutMinute)).second(0);

//     const isPastDate = current.isBefore(today, 'day');

//     if (isPastDate && now.isAfter(cutoffDateTime)) {
//       return true;
//     }
//   }

//   // Disable all past dates (if globally enabled)
//   if (!datePickerRules?.pastDates) {
//     if (current.isBefore(today, 'day')) {
//       return true;
//     }
//   }

//   return false;
// };

export const getDisabledDate = (current: dayjs.Dayjs, datePickerRules?: ISalesDateRules) => {
  if (!current) return false;

  const today = dayjs();
  const now = dayjs();

  // ✅ If no rules → only disable future dates
  if (!datePickerRules) {
    return current.isAfter(today, 'day');
  }

  // Disable future dates (if not allowed)
  if (!datePickerRules.futureDates) {
    if (current.isAfter(today, 'day')) {
      return true;
    }
  }

  // Handle past date limit logic
  if (datePickerRules.enabled) {
    const maxPastDate = today.subtract(datePickerRules.maxDaysBeforeToday, 'day');

    if (current.isBefore(maxPastDate, 'day')) {
      return true;
    }

    const [cutHour, cutMinute] = datePickerRules.cutoffTime.split(':');

    const cutoffDateTime = today.hour(Number(cutHour)).minute(Number(cutMinute)).second(0);

    const isPastDate = current.isBefore(today, 'day');

    if (isPastDate && now.isAfter(cutoffDateTime)) {
      return true;
    }
  }

  // Disable past dates (if not allowed)
  if (!datePickerRules.pastDates) {
    if (current.isBefore(today, 'day')) {
      return true;
    }
  }

  return false;
};
